import { cloneDeep } from 'lodash-es'
import { ref } from 'vue'

const colorInfo = ref<any>(null)
const colorType = ref<'pure' | 'linear' | null>(null)

export function useColorCopy() {
  function colorCopyFn(type: 'pure' | 'linear' | null, color: any) {
    colorType.value = type
    colorInfo.value = cloneDeep(color)
  }
  return {
    colorInfo,
    colorType,
    colorCopyFn
  }
}
